import { useState } from 'react';

const useResize = ()=>{
    const [size,setSize] = useState({width:null,height:200});
    const [resizing,setResizing] = useState(false);
    const onMouseDown = ()=>{
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        setResizing(true);
    }
    const onMouseUp = () =>{
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("mouseup", onMouseUp);
          setResizing(false);
    }
    const onMouseMove = (e) => {
        setSize(currentSize => ({ 
          width: currentSize.width + e.movementX , 
          height: currentSize.height + e.movementY 
        }));
    }

    const setFileSize = (sized) => {
        setSize(sized)
    }

    return [size,onMouseDown, resizing, setFileSize];
}


export default useResize;